import { Folder, Header, registerFileListHeaders } from '@nextcloud/files';
import Vue from 'vue';
/**
 * Register the  "note to recipient" as a files list header
 */
export default function registerNoteToRecipient() {
    let FilesHeaderNoteToRecipient;
    let instance;
    registerFileListHeaders(new Header({
        id: 'note-to-recipient',
        order: 0,
        // Always if there is a note
        enabled: (folder) => Boolean(folder.attributes.note),
        // Update the root folder if needed
        updated: (folder) => {
            if (instance) {
                instance.updateFolder(folder);
            }
        },
        // render simply spawns the component
        render: async (el, folder) => {
            if (FilesHeaderNoteToRecipient === undefined) {
                const { default: component } = await import('../views/FilesHeaderNoteToRecipient.vue');
                FilesHeaderNoteToRecipient = Vue.extend(component);
            }
            instance = new FilesHeaderNoteToRecipient().$mount(el);
            instance.updateFolder(folder);
        },
    }));
}
